import { PRODUCT_LIST_INTERACTION_TYPES } from "../consts";
import {
  Events,
  ProductListInteractionContext,
  ProductListInteractionType,
} from "../types";

import { submitSPEvents } from "./emitSnowplowEvent";

export function emitProductListInteraction({
  interaction,
  category,
  category_secondary,
  category_tertiary,
  product_id,
  offer_id,
  source_id,
  source_type,
  source_position,
  srtrev,
  from_product_ids,
  from_product_offer_id,
  from_product_displayed_price,
}: Omit<ProductListInteractionContext["options"], "interaction"> & {
  interaction?: ProductListInteractionType;
}) {
  submitSPEvents<ProductListInteractionContext>([
    {
      context: Events.PRODUCT_LIST_INTERACTION,
      options: {
        interaction: interaction
          ? PRODUCT_LIST_INTERACTION_TYPES[interaction]
          : PRODUCT_LIST_INTERACTION_TYPES.click,
        category: category || null,
        category_secondary: category_secondary || null,
        category_tertiary: category_tertiary || null,
        product_id,
        offer_id,
        source_id: source_id || null,
        source_type: source_type || null,
        source_position: source_position || null,
        srtrev,
        from_product_ids,
        from_product_offer_id,
        from_product_displayed_price,
      },
    },
  ]);
}
